import { createFileRoute } from "@tanstack/react-router";

import { UpdateProfilePage } from "~/features/dashboard/pages/settings/pages/update-profile";

export const Route = createFileRoute(
  "/(dashboard)/dashboard/$program/settings/user-profile",
)({
  component: () => (
    <section
      role="region"
      aria-label="User profile settings"
      className="min-h-screen w-full px-4 sm:px-[32px] md:px-[208px]"
    >
      <UpdateProfilePage />
    </section>
  ),
  errorComponent: ({ error }: { error: Error }) => (
    <div
      role="alert"
      className="flex min-h-screen items-center justify-center p-4"
    >
      <div className="text-center">
        <h1 className="text-2xl font-bold">Error Loading Profile Settings</h1>
        <pre className="mt-4">{error.message}</pre>
      </div>
    </div>
  ),
});
